const HTTP_LOCALHOST = 'http://localhost:3000/graphql';
const WS_LOCALHOST = 'ws://localhost:3000/graphql-ws';
const WS_LOCALHOST2 = 'ws://localhost:3002/graphql-ws';
const THIRD_PARTY_GOOGLE_FORM_LINK = 'https://forms.gle/L9Gb4yi8TvQtMjfb7';
export const AUTH_TOKEN = 'AUTH_TOKEN';
export const LOGIN_TYPE = 'LOGIN_TYPE';
export const HTTP_ENDPOINT = process.env.VUE_APP_GRAPHQL_HTTP || HTTP_LOCALHOST;
export const WS_ENDPOINT = process.env.VUE_APP_GRAPHQL_WS || WS_LOCALHOST;
export const WS_ENDPOINT2 = process.env.VUE_APP_GRAPHQL_WS2 || WS_LOCALHOST2; // for inbox message subscriptions
export const PESO_SYMBOL = '₱';
export const ECOMMERCE_PRODUCT_MENU_KEY = 'ecommerce-products';
export const ECOMMERCE_CART_MENU_KEY = 'ecommerce-cart';
export const STORE_SETUP_MENU_KEY = 'store-setup-key';
export const ECOMMERCE_ORDER_MENU_KEY = 'ecommerce-orders';
export const ECOMMERCE_MARKETING_MENU_KEY = 'ecommerce-marketing-tools';
export const ECOMMERCE_PAGINATION_OPTIONS = [10, 20, 50, 100];
export const PAGINATION_OPTIONS = [10, 20, 50, 'All'];
export const NAV_DRAWER = 'navigation_drawer';
export const CUSTOMER_SEGMENT = 'Customer Segment';
export const DATA_TABLES_ITEMS = [10, 20, 30];
export const DATETIME_DISPLAY_FORMAT = 'YYYY-MM-DD hh:mm a';
export const SHORTDATE_FORMAT = 'YYYY-MM-DD';
export const FULL_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm';
export const LONGDATE_FORMAT = 'LL';
export const TIME_FORMAT = 'HH:mm';
export const PER_PAGE = 10;
export const ORDER_TRACKER_PER_PAGE = 15;
export const EXPORT_PER_PAGE = 25;
export const DEBOUNCE = 500;
export const SHOPIFY_PRODUCT_MENU_KEY = 'shopify-products';
export const SHOPIFY_CART_MENU_KEY = 'shopify-cart';
export const SHOPIFY_ORDER_MENU_KEY = 'shopify-orders';
export const SHOPIFY_MARKETING_MENU_KEY = 'shopify-marketing-tools';
export const DIY_DEFAULT_APP_NAMES = ['Ecommerce B2C Bundle App', 'Shopify Bundle App'];
export const OVERVIEW_THUMBNAIL_SIZE = '40';
export const THIRD_PARTY_PAYMENTS_APPLICATION_LINK = process.env.THIRD_PARTY_PAYMENTS_APPLICATION_LINK || THIRD_PARTY_GOOGLE_FORM_LINK;
export const FACEBOOK_PIXEL_ID = process.env.VUE_APP_FACEBOOK_PIXEL_ID || '';
export const SEGMENT_WRITE_KEY = process.env.VUE_APP_SEGMENT_WRITE_KEY || '';
export const CDN_URL = 'https://chatgeniecdn.blob.core.windows.net/cdn-chatgenie-ph/';
export const CONTACT_FORM = 'https://forms.gle/BNbcR6avvGai2HXDA';
export const GRAB_EXPRESS_ALLOWED_REGIONS = ['04', '13', '07'];
export const LALAMOVE_ALLOWED_REGIONS = ['03', '13', '07'];
export const CG_API_BASE = process.env.VUE_APP_CG_API_BASE || '';
export const CG_CMS_BASE = process.env.VUE_APP_CG_CMS_BASE || '';
export const LALAMOVE_CEBU_CITIES = [
    '072214',
    '072217',
    '072218',
    '072219',
    '072220',
    '072260',
    '072232',
    '072234',
    '072241',
    '072230',
    '072226',
    '072250',
];
export const LALAMOVE_PAMAPANGA_CITIES = [
    '035401',
    '035402',
    '035403',
    '035404',
    '035405',
    '035406',
    '035407',
    '035408',
    '035409',
    '035410',
    '035411',
    '035412',
    '035413',
    '035414',
    '035415',
    '035416',
    '035417',
    '035418',
    '035419',
    '035420',
    '035421',
    '035422',
];
export const GRAB_EXPRESS_RIZAL_CITIES = [
    '045801',
    '045802',
    '045805',
    '045808',
    '045811',
    '045813',
];
export const GRAB_EXPRESS_CAVITE_CITIES = [
    '042103',
    '042106',
    '042105',
    '042111',
    '042108',
    '042115',
    '042122',
    '042116',
    '042117',
    '042119',
];
export const GRAB_EXPRESS_CEBU_CITIES = [
    '072217',
    '072230',
    '072226',
    '072250',
];
// GOOGLE MAPS CONSTANTS
export const GOOGLE_PLATFORM_KEY = process.env.VUE_APP_GOOGLE_PLATFORM_KEY || '';
export const DEFAULT_LAT = 14.603223252462422;
export const DEFAULT_LNG = 121.09209399651263;
export const MAX_FILE_SIZE = 5000000;
export const MOBILE_MASK = '(###) ###-####';
export const PHONE_MASK = '####-####';
export const CG_BASE_URL = [
    'chatgenie.ph',
    'staging-client-chatgenie.gorated.ph',
    'localhost:8080',
];
export const JWT_HMAC_SECRET = process.env.VUE_APP_JWT_HMAC_SECRET;
export const AES_SECRET_KEY = process.env.VUE_APP_AES_SECRET_KEY;
export const GOOGLE_TAG_MANAGER_KEY = process.env.VUE_APP_GOOGLE_TAG_MANAGER_KEY || '';
export const AWS_SL_SAML_LOGOUT_URL = process.env.VUE_APP_AWS_SL_SAML_LOGOUT_URL || '';
export const AWS_SL_SAML_LOGIN_URL = process.env.VUE_APP_AWS_SL_SAML_LOGIN_URL || '';
export const IDLE_TIMESTAMP = '_sessionTimestamp';
export const IDLE_TIMESTAMP_TO = '_sessionMaxTimestamp';
/* eslint-disable no-useless-escape */
export const PASSWORD_REGEXP = new RegExp(`^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^0-9a-zA-Z])(?!.*[\'"&])(?!.* )(?=.{8,})`);
/* eslint-enable no-useless-escape */
export const USERPILOT_APP_TOKEN = process.env.VUE_APP_USERPILOT_APP_TOKEN || '';
export const BUGSNAG_API_KEY = process.env.VUE_APP_BUGSNAG_API_KEY || ' ';
export const PRIMARY_APP_DEFAULT_ERR_MSG = '(#100) Cannot delete persistent menu because your app is not set as the primary app for the page. (subcode: 2018297).';
export const PRIMARY_APP_NEW_ERR_MSG = 'Please make sure that ChatGenie is the primary app on your page. You can check our video guide for help.';
